import { Button, Dropdown, Grid } from "antd";
import { ItemType } from "antd/es/menu/interface";
import Globe from "../../../../assets/images/icons/Globe";
import CustomDrawer from "../../../CustomDrawer";
import { LanguageResponse } from "../../data";
import styles from "./styleModule";

const LanguageContainer = ({
  languageDropdown,
  onClick,
  handleOpenChange,
  setShowDrawer,
  onClose,
  showDrawer,
  renderLanguageList,
}: {
  languageDropdown: LanguageResponse[];
  onClick: (e: any) => void;
  handleOpenChange: (open: boolean) => void;
  setShowDrawer: (value: boolean) => void;
  onClose: () => void;
  showDrawer: boolean;
  renderLanguageList: () => React.ReactNode;
}) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    <div>
      {screens.md ? (
        <Dropdown
          menu={{ items: languageDropdown as ItemType[], onClick }}
          trigger={["click"]}
          placement="bottomRight"
          onOpenChange={handleOpenChange}
        >
          <Button
            className={styles.globeIcon}
            size={"middle"}
            type="primary"
            icon={
              <Globe
                style={
                  screens.md
                    ? { fontSize: 24, color: "var(--Neutral-light-10)" }
                    : {
                        fontSize: 20,
                        color: "var(--primary-90)",
                      }
                }
              />
            }
          />
        </Dropdown>
      ) : (
        <Button
          className={styles.globeIcon}
          shape={"circle"}
          size={"small"}
          onClick={() => {
            setShowDrawer(true);
          }}
          style={{
            background: "var(--bg)",
            filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.20))",
          }}
          type="primary"
          icon={
            <Globe
              style={
                screens.md
                  ? { fontSize: 24, color: "var(--Neutral-light-10)" }
                  : {
                      fontSize: 20,
                      color: "var(--primary-90)",
                    }
              }
            />
          }
        />
      )}
      <CustomDrawer
        placement={"left"}
        closable={true}
        onClose={onClose}
        open={showDrawer}
        size={"large"}
        width={"100vw"}
      >
        <div className={styles.drawerBodyContainer}>{renderLanguageList()}</div>
      </CustomDrawer>
    </div>
  );
};

export default LanguageContainer;
